import { Button } from '@monksflow/monks-ui';
import { FrownIcon, PlusIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { FormSectionV2, PersonaRepeaterRows } from '../../PersonaFormSectionsV2';
import { isNestedFieldRequired } from '../EditPersonaForm.schema';
import { useEditPersonaFormContext } from '../hooks/useEditPersonaFormContext';

// eslint-disable-next-line i18next/no-literal-string -- react-hook-form field-array name, not copy
const FIELD_ARRAY_NAME = 'pains';
// eslint-disable-next-line i18next/no-literal-string -- react-hook-form field path, not copy
const DESCRIPTION_FIELD = 'description';

export function PainsSectionV2() {
  const { t } = useTranslation('audiences');
  const { control, painsArray } = useEditPersonaFormContext();

  return (
    <FormSectionV2
      icon={<FrownIcon className="size-5" />}
      title={t('audiences.painsSection.pains')}
      headerAction={
        <Button variant="outline" size="sm" onClick={() => painsArray.append({ description: '' })}>
          <PlusIcon className="size-4" />
          {t('audiences.painsSection.addPain')}
        </Button>
      }
    >
      <PersonaRepeaterRows
        control={control}
        name={FIELD_ARRAY_NAME}
        fields={painsArray.fields}
        onRemove={painsArray.remove}
        columns={[
          {
            name: DESCRIPTION_FIELD,
            label: t('audiences.painsSection.description'),
            required: isNestedFieldRequired('pains', 'description'),
          },
        ]}
      />
    </FormSectionV2>
  );
}

PainsSectionV2.displayName = 'PainsSectionV2';
